import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import React, { ComponentType, lazy, ReactNode, Suspense } from 'react'

/**
 * HOC to wrap a component with React.lazy and Suspense for code splitting.
 * @param importFunc - The function to dynamically import the component.
 * @returns The wrapped component with lazy loading.
 */
export const withLazyLoad = <TProps extends object>(
    importFunc: () => Promise<{ default: ComponentType<TProps> }>,
    fallback: ReactNode = <CircularProgress size={16} />
) => {
    const LazyComponent = lazy(importFunc)

    return (props: TProps) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    )
}
